import { array, string, func, bool } from 'prop-types'

import SeriesList from './SeriesList/index.js'
import FilterList from './FilterList/index.js'
import StocksTable from './StocksTable/index.js'
import ProductsList from './ProductsList/index.js'
import LoadingIcon from '../LoadingIcon/index.js'

function Page(props) {
  const {
    stocksData,
    productsData,
    getStocks,
    setCurSeries,
    search,
    setSearch,
    hideEmpty,
    setHideEmpty,
    sortBy,
    setSortBy,
    isLoading,
  } = props
  return (
    <div style={{ position: 'absolute', left: 0 }}>
      <LoadingIcon open={isLoading} />
      <SeriesList {...props} />
      <FilterList
        {...{ search, setSearch, hideEmpty, setHideEmpty, sortBy, setSortBy }}
      />
      {Array.isArray(stocksData) && stocksData.length > 0 ? (
        <StocksTable {...{ stocksData, search, hideEmpty }} />
      ) : (
        <ProductsList {...{ productsData, getStocks, setCurSeries, search }} />
      )}
    </div>
  )
}
Page.propTypes = {
  stocksData: array,
  productsData: array,
  getStocks: func.isRequired,
  setCurSeries: func.isRequired,
  search: string,
  setSearch: func.isRequired,
  hideEmpty: bool.isRequired,
  setHideEmpty: func.isRequired,
  sortBy: string,
  setSortBy: func.isRequired,
  isLoading: bool.isRequired,
}

export default Page
